import Layout from './layout';

export default Layout;



// WEBPACK FOOTER //
// ./src/structure/layout/index.js